const SendTo = $launcher => {
  const url = $launcher.getAttribute('send-ajax-route')

  $launcher.setAttribute('sent-ajax', true)

  axios.post(url, {
    "model": $launcher.getAttribute('send-ajax-data-model'), //Puede ser "advertisement" u "offer"
    "model_id": $launcher.getAttribute('send-ajax-data-model-id'),
    "subject": $launcher.getAttribute('send-ajax-data-subject'), // Puede ser lo que sea.
  })
  .then(response => {
    console.log(response)
  })
  .catch(error => {
    console.log(error)
  })
}

export const SendAjaxOnClick = () => {
    const $launchers = document.querySelectorAll('[send-ajax-click')

    if (!$launchers.length > 0) return

    $launchers.forEach($launcher => {
      $launcher.addEventListener('click', () => {
        if ($launcher.hasAttribute('sent-ajax')) return

        SendTo($launcher)
      })
    })
}
